import { Badge } from "antd"

const AppItem = ({ item, pendingList, onMenuClick, navigate, more }) => {
    // Special case: "OA" code shows drawer
    if (item.code === "OA") {
        return (
            <div onClick={() => item.onSpecialAction()} className="item-menu">
                <img style={{ margin: 7, maxWidth: 100 }} className="logo-menu" src={more} alt="" />
            </div>
        )
    }

    // Special case: "PA" code with badge
    if (item.badge && item.code === "PA") {
        return (
            <Badge count={pendingList} size="default" showZero>
                <div
                    onClick={async () => {
                        await onMenuClick(item)
                        navigate(item.navigate)
                    }}
                    className="item-menu"
                >
                    <img className="logo-menu" src={item.icon} alt={item.nickname} />
                </div>
            </Badge>
        )
    }

    // Badge without "PA" code
    if (item.badge) {
        return (
            <div
                onClick={async () => {
                    await onMenuClick(item)
                    navigate(item.navigate)
                }}
                className="item-menu"
            >
                <img style={{ borderRadius: 14 }} className="logo-menu" src={item.icon} alt={item.nickname} />
            </div>
        )
    }

    // Default case: regular menu item
    return (
        <div
            className="item-menu"
            onClick={async () => {
                await onMenuClick(item)
                navigate(item.navigate)
            }}
        >
            <img className="logo-menu" src={item.icon} alt={item.nickname} />
        </div>
    )
}

export default AppItem
